'use strict';

var DefaultMockType = /*#__PURE__*/function (DefaultMockType) {
  DefaultMockType["SMART_MOCK_FIRST"] = "smartMockFirst";
  DefaultMockType["RESPONSE_EXAMPLE_FIRST"] = "responseExampleFirst";
  return DefaultMockType;
}({});
var HttpsVersion = /*#__PURE__*/function (HttpsVersion) {
  HttpsVersion["HTTP2"] = "HTTP/2";
  HttpsVersion["HTTP1"] = "HTTP/1";
  return HttpsVersion;
}({});
var ParameterDisplayMode = /*#__PURE__*/function (ParameterDisplayMode) {
  ParameterDisplayMode["MODERN"] = "MODERN";
  ParameterDisplayMode["CLASSIC"] = "CLASSIC";
  return ParameterDisplayMode;
}({});
var HttpVersion = /*#__PURE__*/function (HttpVersion) {
  HttpVersion["HTTP1"] = "HTTP/1";
  HttpVersion["HTTP2_WITH_PRIOR_KNOWLEDGE"] = "HTTP/2-with-prior-knowledge";
  return HttpVersion;
}({});
var FOLDER_EXPAND_MODE = /*#__PURE__*/function (FOLDER_EXPAND_MODE) {
  FOLDER_EXPAND_MODE["AUTO"] = "AUTO";
  FOLDER_EXPAND_MODE["MANUAL"] = "MANUAL";
  return FOLDER_EXPAND_MODE;
}({});
var URL_DEFAULT_RULES = /*#__PURE__*/function (URL_DEFAULT_RULES) {
  URL_DEFAULT_RULES["SLUGIFY_WITH_RESOURCE_KEY"] = "SLUGIFY_WITH_RESOURCE_KEY";
  URL_DEFAULT_RULES["RESOURCE_KEY_ONLY"] = "RESOURCE_KEY_ONLY";
  return URL_DEFAULT_RULES;
}({});
var URL_RESOURCE_KEY_STANDARD = /*#__PURE__*/function (URL_RESOURCE_KEY_STANDARD) {
  URL_RESOURCE_KEY_STANDARD["NEW"] = "NEW";
  URL_RESOURCE_KEY_STANDARD["LEGACY"] = "LEGACY";
  return URL_RESOURCE_KEY_STANDARD;
}({});
var URL_RESOURCE_KEY_TYPE_ABBR = /*#__PURE__*/function (URL_RESOURCE_KEY_TYPE_ABBR) {
  URL_RESOURCE_KEY_TYPE_ABBR["Endpoint"] = "e0";
  URL_RESOURCE_KEY_TYPE_ABBR["Doc"] = "m0";
  URL_RESOURCE_KEY_TYPE_ABBR["ApiFolder"] = "f0";
  URL_RESOURCE_KEY_TYPE_ABBR["WebSocketEndpoint"] = "w0";
  URL_RESOURCE_KEY_TYPE_ABBR["CustomEndpoint"] = "c0";
  URL_RESOURCE_KEY_TYPE_ABBR["SocketIOEndpoint"] = "s0";
  URL_RESOURCE_KEY_TYPE_ABBR["DataSchema"] = "d0";
  return URL_RESOURCE_KEY_TYPE_ABBR;
}({});
var SampleCodeAutoGenerateForType = /*#__PURE__*/function (SampleCodeAutoGenerateForType) {
  SampleCodeAutoGenerateForType["All"] = "ALL";
  SampleCodeAutoGenerateForType["Custom"] = "CUSTOM";
  return SampleCodeAutoGenerateForType;
}({});
var defaultSampleCode = {
  enable: true,
  autoGenerateFor: SampleCodeAutoGenerateForType.All,
  customAutoGenerate: undefined,
  overwriteExisting: true
};
var CloudMockSecurityEnum = /*#__PURE__*/function (CloudMockSecurityEnum) {
  CloudMockSecurityEnum["Free"] = "free";
  CloudMockSecurityEnum["Token"] = "token";
  return CloudMockSecurityEnum;
}({});
exports.CloudMockSecurityEnum = CloudMockSecurityEnum;
exports.DefaultMockType = DefaultMockType;
exports.FOLDER_EXPAND_MODE = FOLDER_EXPAND_MODE;
exports.HttpVersion = HttpVersion;
exports.HttpsVersion = HttpsVersion;
exports.ParameterDisplayMode = ParameterDisplayMode;
exports.SampleCodeAutoGenerateForType = SampleCodeAutoGenerateForType;
exports.URL_DEFAULT_RULES = URL_DEFAULT_RULES;
exports.URL_RESOURCE_KEY_STANDARD = URL_RESOURCE_KEY_STANDARD;
exports.URL_RESOURCE_KEY_TYPE_ABBR = URL_RESOURCE_KEY_TYPE_ABBR;
exports.defaultSampleCode = defaultSampleCode;
